import { failedTestArtifactsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const failedTestArtifacts =
  cachedRequestByIdReducer(failedTestArtifactsActionTypes, 'byJobId');
export default failedTestArtifacts;

const getFailedTestArtifactsState = state => state.failedTestArtifacts;
export const failedTestArtifactsByJobIds = state =>
  getFailedTestArtifactsState(state).byJobId;
export const getFailedTestArtifactsByJobId = (state, jobId) =>
  failedTestArtifactsByJobIds(state)[jobId];


// WEBPACK FOOTER //
// src/reducers/failedTestArtifacts.js